/* Best Sellers carousel — scroll-snap track with auto-advance.
   Pairs with sections/best-sellers.liquid.
   Autoplay (~4s, configurable via data-bs-speed) pauses on hover,
   touch, focus, tab-hide, and when scrolled off-screen. Disabled
   entirely for prefers-reduced-motion users. */
(function () {
  function pageStep(track) {
    var card = track.querySelector('.bs-card');
    if (!card) return 0;
    var styles = window.getComputedStyle(track);
    var gap = parseFloat(styles.columnGap || styles.gap) || 0;
    return card.getBoundingClientRect().width + gap;
  }

  function initSection(root) {
    var track = root.querySelector('[data-bs-track]');
    if (!track) return;
    var cards = track.querySelectorAll('.bs-card');
    if (cards.length < 2) return;

    var autoplay = root.getAttribute('data-bs-autoplay') === 'true';
    var speed = parseInt(root.getAttribute('data-bs-speed'), 10) || 4000;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var prev = root.querySelector('[data-bs-prev]');
    var next = root.querySelector('[data-bs-next]');
    var dotsWrap = root.querySelector('[data-bs-dots]');

    function maxScroll() {
      return Math.max(0, track.scrollWidth - track.clientWidth);
    }
    function atEnd() {
      return track.scrollLeft >= maxScroll() - 4;
    }
    function goNext() {
      var step = pageStep(track);
      if (!step) return;
      if (atEnd()) {
        track.scrollTo({ left: 0, behavior: 'auto' }); // instant wrap
      } else {
        track.scrollBy({ left: step, behavior: 'smooth' });
      }
    }
    function goPrev() {
      var step = pageStep(track);
      if (!step) return;
      track.scrollBy({ left: -step, behavior: 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { goPrev(); restart(); });
    if (next) next.addEventListener('click', function () { goNext(); restart(); });

    /* Dots: one per card, click scrolls to that card, active follows scroll */
    var dots = [];
    if (dotsWrap) {
      cards.forEach(function (card, i) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'bs-dot';
        dot.setAttribute('role', 'tab');
        dot.setAttribute('aria-label', 'Go to product ' + (i + 1));
        dot.addEventListener('click', function () {
          var step = pageStep(track);
          if (!step) return;
          track.scrollTo({ left: i * step, behavior: 'smooth' });
          restart();
        });
        dotsWrap.appendChild(dot);
        dots.push(dot);
      });
    }
    var ticking = false;
    function updateDots() {
      ticking = false;
      if (!dots.length) return;
      var step = pageStep(track);
      if (!step) return;
      var idx = Math.round(track.scrollLeft / step);
      idx = Math.max(0, Math.min(dots.length - 1, idx));
      dots.forEach(function (dot, i) {
        var active = i === idx;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }
    track.addEventListener('scroll', function () {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(updateDots);
      }
    }, { passive: true });
    updateDots();

    /* Autoplay with all the pause conditions */
    var timer = null;
    var userPaused = false;
    var inView = true;

    function start() {
      if (timer || !autoplay || reduceMotion || userPaused || !inView || document.hidden) return;
      timer = setInterval(goNext, speed);
    }
    function stop() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }
    function restart() {
      stop();
      start();
    }

    root.addEventListener('mouseenter', function () { userPaused = true; stop(); });
    root.addEventListener('mouseleave', function () { userPaused = false; start(); });
    root.addEventListener('focusin', function () { userPaused = true; stop(); });
    root.addEventListener('focusout', function () { userPaused = false; start(); });
    track.addEventListener('touchstart', function () { userPaused = true; stop(); }, { passive: true });
    track.addEventListener('touchend', function () {
      setTimeout(function () { userPaused = false; start(); }, 2500);
    }, { passive: true });
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop(); else start();
    });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            inView = entry.intersectionRatio >= 0.25;
            if (inView) start(); else stop();
          });
        },
        { threshold: [0, 0.25, 1] }
      );
      io.observe(root);
    }

    start();
  }

  function init() {
    document.querySelectorAll('[data-best-sellers]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
